import {
  IonText,
  IonRow,
  IonCol,
  IonCard,
  IonItem,
  IonLabel,
  IonButton,
  IonDatetime,
  useIonToast,
} from "@ionic/react";
import { useEffect, useState } from "react";
import { UserFile } from "../../../@types/userFiles";
import { FileHolder } from "../../../@types/fileHolder";
import { useDispatch } from "react-redux";
import { uploadFileCompliance } from "../../../store/userShow/actions/uploadFileCompliance";
import api from "../../../utils/api";

interface ComponentProps {
  document: UserFile[];
  userId: string;
  ownerId: string;
}

const thisYear = new Date().getFullYear();
const limitYear = thisYear + 3;

export const RejectedDocumentUpdate: React.FC<ComponentProps> = ({ document, userId, ownerId }:any) => {
  const [selectedDate, setSelectedDate] = useState<string>("");
  const [fileHolder, setFileHolder] = useState<FileHolder[]>([]);
  const [presentToast, hideToast] = useIonToast();
  const dispatch = useDispatch();
  const rejectedDocument = document[0].documents.filter(
    (document:any) => document.complianceStatus === "devuelto"
  );
  const mustUploadDocument = document[0].documents.filter(
    (document:any) => document.complianceStatus === "creacion"
  );

  let documentInfoToPost: any[] = [];

  const correctDocumentContainer = () => {
    if (rejectedDocument.length > 0) {
      documentInfoToPost = rejectedDocument;
    } else {
      documentInfoToPost = mustUploadDocument;
    }
  };

  const onSelectFile = (e: any) => {
    const newFileHolder = [
      {
        file: e.target.files[0],
        id: documentInfoToPost[0].complianceId,
        userId: userId,
        ownerId: ownerId,
        expirationDate: "",
      },
    ];
    setFileHolder(newFileHolder);
  };

  useEffect(() => {
    if (fileHolder.length > 0) {
      fileHolder[0].expirationDate = selectedDate;
    }
  }, [selectedDate]);

  const handleSendNotification = async (fileHolder: FileHolder[]) => {
    if (fileHolder.length === 0) {
      presentToast({
        message: "Debe subir un archivo antes de guardar",
        color: "danger",
        duration: 3000,
      });
    } else {
      try {
        await hideToast();
        presentToast({
          message: `Cargando archivo...`,
          color: "primary",
        });
        if (fileHolder.length > 0) {
          const { payload: notificationCreated }: any =
            (await dispatch(uploadFileCompliance(fileHolder))) || {};
          if (!notificationCreated) {
            throw new Error("No se pudo cargar el archivo");
          }
        }
        await hideToast();
        presentToast({
          message: `Se cargó correctamente el archivo`,
          color: "success",
          duration: 8000,
        });
      } catch (error) {
        await hideToast();
        presentToast({
          message: "Ocurrió un problema al enviar el archivo",
          color: "danger",
          duration: 8000,
        });
      }
    }
  };

  correctDocumentContainer();

  const handleDownloadRejectedFile = async (fileId: string) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${api.baseURL}archive/get-file?idCompliance=${fileId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);

        // Simular clic en un enlace para descargar el archivo
        const link = document.createElement("a"); // Aquí es donde se usa createElement correctamente
        link.href = url;
        link.setAttribute("download", "rejected-file");
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        console.error("Error fetching file:", response.statusText);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  return (
    <>
      <IonCard className="ion-margin-start">
        {rejectedDocument.length > 0 ? (
          <IonItem style={{ justifyContent: "center", display: "flex" }}>
            <IonRow style={{ width: "100%", padding: 20 }}>
              <IonCol style={{ textAlign: "center" }}>
                <IonText color="primary">Nota de Rechazo:</IonText>
                {rejectedDocument[0].comments! != undefined ? (
                  <>
                    <IonLabel>
                      <p>{rejectedDocument[0].comments!.slice(-1)[0].comentario}</p>
                    </IonLabel>
                    <IonRow style={{ textAlign: "center" }}>
                      <IonCol>
                        <IonButton
                          style={{ height: 40 }}
                          onClick={() => {
                            const archivoId = rejectedDocument[0].comments?.slice(-2, -1)[0]
                              ?.archivo_id;
                            if (archivoId) {
                              handleDownloadRejectedFile(archivoId);
                            } else {
                              // Manejar el caso donde archivoId es undefined, por ejemplo:
                              console.error("archivo_id is undefined");
                            }
                          }}
                        >
                          Ver Archivo Rechazado
                        </IonButton>
                      </IonCol>
                    </IonRow>
                  </>
                ) : (
                  <p>No hay información disponible</p>
                )}
              </IonCol>
            </IonRow>
          </IonItem>
        ) : null}
        <IonItem style={{ justifyContent: "center", display: "flex" }}>
          <IonRow style={{ width: "100%", padding: 20 }}>
            <IonCol style={{ justifyContent: "center", display: "flex" }}>
              <IonText color="primary">
                {rejectedDocument.length > 0
                  ? rejectedDocument[0].title
                  : mustUploadDocument[0].title}
              </IonText>
            </IonCol>
          </IonRow>
        </IonItem>
        <IonItem>
          <IonRow style={{ width: "100%", padding: 20 }}>
            <IonCol style={{ textAlign: "center" }}>
              <IonButton color="primary" style={{ fontWeight: 300 }} size={"default"}>
                <label htmlFor="docButton" style={{ cursor: "pointer" }}>
                  <IonLabel>
                    <p style={{ fontWeight: 500 }}>SUBIR DOCUMENTO</p>
                  </IonLabel>
                </label>
              </IonButton>
              <input
                type="file"
                id="docButton"
                name={`${document[0].name}`}
                style={{ display: "none" }}
                onChange={(event) => onSelectFile(event)}
                accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                required
              />
              <IonLabel>
                {fileHolder.length > 0 ? <p>{fileHolder[0].file.name}</p> : <p>Nombre Archivo</p>}
              </IonLabel>
            </IonCol>
          </IonRow>
        </IonItem>
        {document[0].datesRequire === true && (
          <IonItem>
            <IonRow style={{ width: "100%", padding: 20 }}>
              <IonCol style={{ textAlign: "center" }}>
                <IonLabel>
                  <IonDatetime
                    displayFormat=" DD MMM, YYYY"
                    placeholder="Seleccione Fecha"
                    monthShortNames="Enero, Febrero, Marzo, Abril, Mayo, Junio, Julio, Agosto, Sept, Oct, Nov, Dic"
                    min={`${thisYear}`}
                    max={`${limitYear}`}
                    doneText="Aceptar"
                    cancelText="Cancelar"
                    value={selectedDate}
                    onIonChange={(e) => {
                      const value = e.detail.value;
                      if (value) {
                        setSelectedDate(value);
                      }
                    }}
                  ></IonDatetime>
                </IonLabel>
                <IonLabel>
                  <p>Fecha de vencimiento</p>
                </IonLabel>
              </IonCol>
            </IonRow>
          </IonItem>
        )}
        <IonRow style={{ textAlign: "center", padding: 20 }}>
          <IonCol>
            <IonButton onClick={() => handleSendNotification(fileHolder)}>Guardar</IonButton>
          </IonCol>
        </IonRow>
      </IonCard>
    </>
  );
};
